import FormInput from 'components/Form/FormInput';
import { useEffect, useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';

export interface GroupPopup {
	show: boolean,
	heading: string,
	value: string,
	onSave: (newValue: string) => void,
	onClose: () => void,
}

export const NewGroupPopup = ((props: GroupPopup) => {
	const [value, setValue] = useState<string>('');
	const [valid, setValid] = useState<boolean>(false);

	useEffect(() => {
		setValue(props.value);
	}, [props.value, props.show])

	useEffect(() => {
		setValid(value !== '');
	}, [value])


	return (
		<>
			<Modal
				size="lg"
				centered
				backdrop="static"
				show={props.show}
				onHide={props.onClose}
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.heading}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row className="mb-1">
						<Col>
							<Row>
								<Col md={12}>
									<FormInput
										required
										label="Name"
										type="text"
										name="group-name"
										placeholder="Enter group name"
										containerClass={'mb-3'}
										value={value}
										key="text"
										onChange={(e) => setValue(e.target.value)}
										errors={valid ? undefined : { "group-name": {} }}
									/>
								</Col>
							</Row>
							<Row className='mt-3'>
								<Col sm={6}>
								</Col>
								<Col sm={6} className="d-flex flex-row-reverse">
									<Button
										variant="primary"
										className="btn m-1"
										onClick={() => {
											if (valid) props.onSave(value)
										}}>
										Save
									</Button>
									<Button
										variant="secondary"
										className="btn m-1"
										onClick={() => {
											props.onClose();
										}}
									>
										Cancel
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	);
})